/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchSubRuleBulkUpdateFormValidationData
 */
export interface SearchSubRuleBulkUpdateFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleBulkUpdateFormValidationData
     */
    maxPriceSolutions?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleBulkUpdateFormValidationData
     */
    maxPricePoints?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleBulkUpdateFormValidationData
     */
    maxConnectionTimeHours?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleBulkUpdateFormValidationData
     */
    maxConnectionTimeMinutes?: ValidationMessage;
}

export function SearchSubRuleBulkUpdateFormValidationDataFromJSON(json: any): SearchSubRuleBulkUpdateFormValidationData {
    return SearchSubRuleBulkUpdateFormValidationDataFromJSONTyped(json, false);
}

export function SearchSubRuleBulkUpdateFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleBulkUpdateFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : ValidationMessageFromJSON(json['maxPriceSolutions']),
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : ValidationMessageFromJSON(json['maxPricePoints']),
        'maxConnectionTimeHours': !exists(json, 'maxConnectionTimeHours') ? undefined : ValidationMessageFromJSON(json['maxConnectionTimeHours']),
        'maxConnectionTimeMinutes': !exists(json, 'maxConnectionTimeMinutes') ? undefined : ValidationMessageFromJSON(json['maxConnectionTimeMinutes']),
    };
}

export function SearchSubRuleBulkUpdateFormValidationDataToJSON(value?: SearchSubRuleBulkUpdateFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maxPriceSolutions': ValidationMessageToJSON(value.maxPriceSolutions),
        'maxPricePoints': ValidationMessageToJSON(value.maxPricePoints),
        'maxConnectionTimeHours': ValidationMessageToJSON(value.maxConnectionTimeHours),
        'maxConnectionTimeMinutes': ValidationMessageToJSON(value.maxConnectionTimeMinutes),
    };
}


